import { render, staticRenderFns } from "./gj-logistics-select.vue?vue&type=template&id=355d4fa6&scoped=true&"
import script from "./gj-logistics-select.vue?vue&type=script&lang=js&"
export * from "./gj-logistics-select.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "355d4fa6",
  null
  
)

export default component.exports